import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import cn from "classnames";
import styles from "./NameAndDescription.module.sass";
import { Link } from "react-router-dom";
import Icon from "../../../components/Icon";

// Screens
import CompanyInformations from "./CompanyInformations";
import AddressInformations from "./AddressInformations";
import DirectorInformations from "./DirectorInformations";

// Services
import { updateCompany } from "../../../services/company.service";
import { showSuccess, showError } from "../../../services/toast.service";
import ContactInformations from "./ContactInformations";

const NameAndDescription = ({ company: initialCompany }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [companyData, setCompanyData] = useState({});
  
  // Initialiser les données de l'entreprise lorsque les props changent
  useEffect(() => {
    if (initialCompany) {
      setCompanyData(initialCompany);
    }
  }, [initialCompany]);

  const handleCompanyChange = (e) => {
    const { name, value } = e.target;
    setCompanyData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSwitchChange = (name, value) => {
    setCompanyData((prev) => ({ ...prev, [name]: value }));
  };

  const handleDropdownChange = (name, value) => {
    // Pour les champs numériques, convertir en nombre
    let finalValue = value;
    if ((name === 'type_of_employer' || name === 'specific_employer') && !isNaN(Number(value))) {
      finalValue = Number(value);
    }
    setCompanyData((prev) => ({ ...prev, [name]: finalValue }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      await updateCompany(companyData.id, companyData);
      showSuccess("Entreprise mise à jour avec succès!");
    } catch (err) {
      const errorMessage =
        "Impossible de mettre à jour l'entreprise: " +
        (err.message || "Veuillez vérifier les informations saisies.");
      showError(errorMessage);
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className={styles.container}>
        <div className={styles.formContainer}>
          {error && <div className={styles.error}>{error}</div>}
          <form onSubmit={handleSubmit}>
            <CompanyInformations
              company={companyData}
              onCompanyChange={handleCompanyChange}
              onDropdownChange={handleDropdownChange}
              onSwitchChange={handleSwitchChange}
            />
            <AddressInformations
              company={companyData}
              onCompanyChange={handleCompanyChange}
            />
            <ContactInformations 
              company={companyData}
              onCompanyChange={handleCompanyChange}
            />
            <DirectorInformations
              company={companyData}
              onCompanyChange={handleCompanyChange}
              onDropdownChange={handleDropdownChange}
              loading={loading}
            />          
          </form>
        </div>
      </div>
    </>
  );
};

export default NameAndDescription;
